module.exports = __webpack_public_path__ + "img/home-124226881.572699e9.jpg";